/* eslint-disable */
export default {
  sureToDeleteVoiceMail: 'Haluatko varmasti poistaa tämän vastaajaviestin?',
  sureToDeleteFax: 'Haluatko varmasti poistaa tämän faksin?',
  doNotAskAgain: 'Älä kysy uudelleen',
} as const;

// @key: @#@"sureToDeleteVoiceMail"@#@ @source: @#@"Are you sure you want to delete this voicemail?"@#@
// @key: @#@"sureToDeleteFax"@#@ @source: @#@"Are you sure you want to delete this fax?"@#@
// @key: @#@"doNotAskAgain"@#@ @source: @#@"Don't ask me again"@#@
